/**
 * Create the FAQ Agent node
 */

import { AgentNode, AgentContext, ToolCallResult, VoiceGender } from '../types';
import { requireLanguage, languageDetectedGuardrail } from '../guardrails';
import { searchFAQs, formatSearchResults } from '../../utils/faq-search';

export function createFAQAgent(voiceGender: VoiceGender = 'male'): AgentNode {
  return {
    id: 'faq_agent',
    name: 'FAQ Agent',
    description: 'Handles FAQ and question answering from SAAED knowledge base',
    
    // Initial prompt to trigger AI behavior

    
    // Backend provides the actual system instruction via ephemeral token

    
    // Initial prompt - checks for pending question from router redirect
    initialPrompt: 'You are now in FAQ mode. IMPORTANT: Check if there is a pendingQuestion in your context data. If there IS a pendingQuestion, immediately call search_faq with that question and answer it. If there is NO pendingQuestion, ask the user what question they have about SAAED services, fees, or procedures.',
    
    // Must have language
    entryGuardrails: requireLanguage(),
    
    // Can go back to welcome to ask another question
    exitGuardrails: {
      transitions: new Map([
        ['back_to_menu', {
          target: { agentId: 'welcome_agent' },
          guardrails: [languageDetectedGuardrail],
        }],
      ]),
      fallback: { agentId: 'welcome_agent' },
    },
    
    handleToolCall: async (
      toolName: string,
      args: Record<string, any>,
      context: AgentContext
    ): Promise<ToolCallResult> => {
      if (toolName === 'search_faq') {
        const question = args.question || '';
        const searchResults = await searchFAQs(question, 3, 2);
        
        // Determine language for formatting
        const language = context.transitionData.language || 'en';
        const formattedResults = formatSearchResults(searchResults, language);
        
        console.log('[FAQAgent] Search query:', question);
        console.log('[FAQAgent] Results found:', searchResults.length);
        
        return {
          toolName,
          args,
          result: {
            success: true,
            results_count: searchResults.length,
            results: formattedResults,
            message: searchResults.length > 0 
              ? `Found ${searchResults.length} result(s)`
              : 'No matching results found',
          },
        };
      }
      
      if (toolName === 'back_to_menu') {
        console.log('[FAQAgent] User wants to go back to welcome');
        
        return {
          toolName,
          args,
          result: { 
            success: true,
            message: 'Returning to welcome to ask another question',
          },
          triggersTransition: true,
          transitionTo: 'welcome_agent',
        };
      }
      
      return {
        toolName,
        args,
        result: { success: false, error: 'Unknown tool' },
      };
    },
    
    onActivate: async (context: AgentContext) => {
      console.log('[FAQAgent] Activated - ready to answer questions');
    },
    
    onDeactivate: async (context: AgentContext) => {
      console.log('[FAQAgent] Deactivated');
    },
  };
}

export default createFAQAgent;

